export const onUseSearchDebounce = (debouncedCallback: (search: string) => void, delay: number) => {
    let timer: ReturnType<typeof setTimeout> | null = null
    return (search: string) => {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            debouncedCallback(search)
        }, delay)
    }
}
